var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, Complex, ChildProperty } from '@syncfusion/ej2-base';
import { Margin } from '../core/appearance';
import { DiagramTooltip } from './tooltip';
import { FlipDirection } from '../enum/enum';
import { SymbolPaletteInfo } from './preview';
/**
 * Defines the common behavior of nodes, connectors and groups
 */
var NodeBase = /** @class */ (function (_super) {
    __extends(NodeBase, _super);
    function NodeBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property('')
    ], NodeBase.prototype, "id", void 0);
    __decorate([
        Property(Number.MIN_VALUE)
    ], NodeBase.prototype, "zIndex", void 0);
    __decorate([
        Complex({}, Margin)
    ], NodeBase.prototype, "margin", void 0);
    __decorate([
        Property(true)
    ], NodeBase.prototype, "visible", void 0);
    __decorate([
        Complex({}, DiagramTooltip)
    ], NodeBase.prototype, "tooltip", void 0);
    __decorate([
        Property(false)
    ], NodeBase.prototype, "excludeFromLayout", void 0);
    __decorate([
        Property()
    ], NodeBase.prototype, "addInfo", void 0);
    __decorate([
        Property(FlipDirection.None)
    ], NodeBase.prototype, "flip", void 0);
    __decorate([
        Property('All')
    ], NodeBase.prototype, "flipMode", void 0);
    __decorate([
        Complex({}, SymbolPaletteInfo)
    ], NodeBase.prototype, "symbolInfo", void 0);
    return NodeBase;
}(ChildProperty));
export { NodeBase };
